import { Injectable } from '@angular/core';
import { HttpRequestService } from '../_common/http-request.service';

@Injectable()
export class UserQuestionsService {

    RequestOptions: any = {};

    constructor(
        private http: HttpRequestService,
    ) { }

    gets(parameters) {
        return this.http.get('lineUsersQuestionAndAnswers', parameters)
            .map(res => {
                return res.json();
            })
    }

    delete(id: number) {
        return this.http.delete(`lineUsersQuestionAndAnswers/delete?id=${id}`)
            .map(res => {
                return res.json();
            });
    }

    reply(model: any) {
        return this.http.post('lineUsersQuestionAndAnswer', model)
            .map(res => {
                return res.json();
            });
  }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/user-questions.service.ts